// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5":"78aedf60c3d90a9c0704","334":"ddd378171b02da87f527"}[chunkId] + ".2156.js";
};